export default "__VITE_ASSET__a9b3f41c__"